export const SLIDE_TYPES = [
    'exhibition',
    'exhibitions',
    'room',
    'scene',
    'subscene',
    'footer'
];
export const SLIDE_TYPES_ROOM = [
    'scene',
    'footer'
];
export const WIDGET_TYPES = [
    'AiImage',
    'AnnotationCanvas',
    'AnnotationItem',
    'AudioPlayer',
    'Carousel',
    'CarouselSlide',
    'Column',
    'Columns',
    'CustomCSS',
    'Description',
    'ExGlossaryItem',
    'ExPage',
    'ExPerson',
    'ExPlace',
    'ExSubject',
    'ExTitle',
    'ExternalLink',
    'FocusPoint',
    'FocusPointContent',
    'GlossaryList',
    'Graphic',
    'GraphicGroup',
    'GridElement',
    'iframe',
    'ImageViewer',
    'MenuItem',
    'Modal',
    'ModalContent',
    'More',
    'Quote',
    'SearchTerm',
    'Showcase',
    'TagCloud',
    'TextBlock',
    'TextTicker',
    'TickerPage',
    'Transition',
    'VideoPlayer'
];
export const WIDGET_TAG_MAP = {
    aiimage: 'AiImage',
    annotationcanvas: 'AnnotationCanvas',
    annotationitem: 'AnnotationItem',
    audioplayer: 'AudioPlayer',
    carousel: 'Carousel',
    carouselslide: 'CarouselSlide',
    column: 'Column',
    columns: 'Columns',
    customcss: 'CustomCSS',
    description: 'Description',
    exglossaryitem: 'ExGlossaryItem',
    expage: 'ExPage',
    experson: 'ExPerson',
    explace: 'ExPlace',
    exsubject: 'ExSubject',
    extitle: 'ExTitle',
    externallink: 'ExternalLink',
    focuspoint: 'FocusPoint',
    focuspointcontent: 'FocusPointContent',
    glossarylist: 'GlossaryList',
    graphic: 'Graphic',
    graphicgroup: 'GraphicGroup',
    gridelement: 'GridElement',
    iframe: 'iframe',
    imageviewer: 'ImageViewer',
    menuitem: 'MenuItem',
    modal: 'Modal',
    modalcontent: 'ModalContent',
    more: 'More',
    quote: 'Quote',
    searchterm: 'SearchTerm',
    showcase: 'Showcase',
    tagcloud: 'TagCloud',
    textblock: 'TextBlock',
    textticker: 'TextTicker',
    tickerpage: 'TickerPage',
    transition: 'Transition',
    videoplayer: 'VideoPlayer'
};
export const PROP_TABS = [
    {
        name: 'general',
        icon: 'pencil alternate',
        sections: null
    },
    {
        name: 'styling',
        icon: 'adjust',
        sections: [
            'styling',
            'background',
            'content',
            'graphic'
        ]
    }
];
